import {ButtonAction, DropdownAction, ButtonWithTooltipAction} from 'platform/components';
import {HStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {suffixTestId} from 'shared/web';

import {useResponsiveActions} from '../hooks/useResponsiveActions';
import type {EntityHeaderActionsProps} from '../types';
import {ActionItemWrapper} from './ActionItemWrapper';

export function EntityHeaderActions(props: EntityHeaderActionsProps) {
  const {responsiveActions} = useResponsiveActions({
    actions: props.actions,
    maxVisibleActions: props.maxVisibleActions,
    dropdownPosition: props.dropdownPosition,
  });

  if (isNilOrEmpty(responsiveActions)) {
    return null;
  }

  return (
    <HStack
      spacing={2}
      align="center"
      justify="flex-end"
      data-testid={props['data-testid']}
      wrap={props.wrap}
    >
      {responsiveActions?.map((action, key) => {
        const testId = action['data-testid'] ?? `[${key}]`;

        if (action.type === 'button') {
          return (
            <ActionItemWrapper
              isFullWidth={props.shouldStretchActions}
              key={`buttonAction-[${action.title}]-[${key}]`}
            >
              <ButtonAction
                data-testid={suffixTestId(testId, props)}
                {...action}
                isFullWidth={props.shouldStretchActions}
              />
            </ActionItemWrapper>
          );
        }

        if (action.type === 'buttonWithTooltip') {
          return (
            <ActionItemWrapper
              isFullWidth={props.shouldStretchActions}
              key={`buttonWithTooltipAction-[${action.title}]-[${key}]`}
            >
              <ButtonWithTooltipAction
                data-testid={suffixTestId(testId, props)}
                {...action}
                isFullWidth={props.shouldStretchActions}
              />
            </ActionItemWrapper>
          );
        }

        if (action.type === 'dropdown-button' || action.type === 'dropdown-iconButton') {
          return (
            <DropdownAction
              key={`dropdownAction-[${key}]`}
              data-testid={suffixTestId(testId, props)}
              {...action}
            />
          );
        }
      })}
    </HStack>
  );
}
